import { combineReducers } from 'redux';

import journalDataReducer from './journalDataReducer';
import journalUIReducer from './journalUIReducer';

export default combineReducers({
  ui: journalUIReducer,
  data: journalDataReducer,
});
